import { render, staticRenderFns } from "./fault-manag.vue?vue&type=template&id=56e30b3a"
import script from "./fault-manag.vue?vue&type=script&lang=js"
export * from "./fault-manag.vue?vue&type=script&lang=js"
import style0 from "./fault-manag.vue?vue&type=style&index=0&id=56e30b3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports